import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { gsap } from 'gsap';

const SkeletonLoader = () => {
  useEffect(() => {
    const tl = gsap.timeline({
      repeat: -1,
    });
    
    tl.to('.animate-skeleton', {
      opacity: 0.5,
      duration: 1,
      ease: 'power1.inOut',
    })
    .to('.animate-skeleton', {
      opacity: 1,
      duration: 1,
      ease: 'power1.inOut',
    });
  }, []);

  return (
    <motion.div
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-gray-100 flex justify-center items-center py-5 lg:py-0 px-8 md:px-5 lg:px-10"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4">
          
          {/* Profile Card */}
          <div className="col-span-1 md:col-span-6 lg:col-span-3 bg-white rounded-3xl p-4 shadow-lg">
            <div className="w-full h-32 bg-gray-200 rounded-2xl animate-skeleton mb-4"></div>
            <div className="flex flex-wrap gap-1 mb-4">
              {[1,2,3,4,5,6].map((i) => (
                <div key={i} className="h-6 w-16 bg-gray-200 rounded-full animate-skeleton"></div>
              ))}
            </div>
            <div className="h-24 bg-gray-200 rounded-xl animate-skeleton"></div>
          </div>

          {/* Skills Card */}
          <div className="col-span-1 md:col-span-6 lg:col-span-3 bg-white rounded-3xl p-6 shadow-lg">
            <div className="h-8 w-24 bg-gray-200 rounded animate-skeleton mb-6"></div>
            <div className="grid grid-cols-4 gap-4 mb-6">
              {[1,2,3,4].map((i) => (
                <div key={i} className="aspect-square bg-gray-200 rounded-xl animate-skeleton"></div>
              ))}
            </div>
            <div className="flex gap-4 overflow-hidden">
              {[1,2,3,4,5].map((i) => (
                <div key={i} className="w-16 aspect-square bg-gray-200 rounded-xl animate-skeleton flex-shrink-0"></div>
              ))}
            </div>
          </div>

          {/* Hero Section */}
          <div className="col-span-1 md:col-span-6 lg:col-span-6 row-span-2 bg-white rounded-3xl p-8 shadow-lg">
            <div className="h-6 w-48 bg-gray-200 rounded animate-skeleton mb-4"></div>
            <div className="h-10 w-72 bg-gray-200 rounded animate-skeleton mb-6"></div>
            <div className="space-y-3 mb-8">
              {[1,2,3].map((i) => (
                <div key={i} className="h-4 bg-gray-200 rounded animate-skeleton"></div>
              ))}
            </div>
            <div className="h-12 w-32 bg-gray-200 rounded-full animate-skeleton"></div>
          </div>

          {/* Stats Cards */}
          <div className="col-span-1 md:col-span-6 flex flex-col md:flex-row gap-4">
            {[1,2,3].map((i) => (
              <div key={i} className="flex-1 bg-white rounded-3xl p-6 shadow-lg">
                <div className="h-10 bg-gray-200 rounded animate-skeleton mb-2"></div>
                <div className="h-4 w-16 mx-auto bg-gray-200 rounded animate-skeleton"></div>
              </div>
            ))}
          </div>

          {/* Contact Card */}
          <div className="col-span-1 md:col-span-6 lg:col-span-6 bg-white rounded-3xl p-8 shadow-lg">
            <div className="flex flex-col items-center gap-4">
              <div className="h-6 w-40 bg-gray-200 rounded animate-skeleton"></div>
              <div className="h-8 w-64 bg-gray-200 rounded animate-skeleton"></div>
            </div>
          </div>

          {/* Blog Card */}
          <div className="col-span-1 md:col-span-6 lg:col-span-6 bg-white rounded-3xl p-8 shadow-lg">
            <div className="h-8 w-48 bg-gray-200 rounded animate-skeleton mb-4"></div>
            <div className="h-6 w-72 bg-gray-200 rounded animate-skeleton"></div>
          </div>

          {/* Leadership, Experience, Projects Cards */}
          {[1,2,3].map((i) => (
            <div key={i} className="col-span-1 md:col-span-4 lg:col-span-4 bg-white rounded-3xl p-8 shadow-lg">
              <div className="flex flex-col items-center gap-2">
                <div className="h-4 w-24 bg-gray-200 rounded animate-skeleton"></div>
                <div className="h-8 w-32 bg-gray-200 rounded animate-skeleton"></div>
              </div>
            </div>
          ))}
          
        </div>
      </div>
    </motion.div>
  );
};

export default SkeletonLoader;